export default function initialState() {
    return {
        updates: {
            __loading__: false,
            __error__: null
        }
    };
}
